export const urls = {
    allStateUrl: "https://opensky-network.org/api/states/all",
    flightbyAircraftUrl: "https://opensky-network.org/api/flights/aircraft?icao24=3c675a&begin=1517184000&end=1517270400",
    flightArrivalByAirportUrl: "https://opensky-network.org/api/flights/arrival?airport=EDDF&begin=1517227200&end=1517230800",
    flightDepartureByAirportUrl: "https://opensky-network.org/api/flights/departure?airport=EDDF&begin=1517227200&end=1517230800",
    flightbyTimeIntervalUrl: "https://opensky-network.org/api/flights/all"
}
//"https://opensky-network.org/api/flights/all?begin=1517227200&end=1517230800"